import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { MembershipListFlags, MembershipListType } from 'libs/domain';
import { Subject, lastValueFrom } from 'rxjs';

import { MembershipListTableData } from '@app/src/app/shared/components/membership-list-table';
import { ModalOverlayService, ModalOverlayServiceCloseEventType } from '@app/src/app/shared/components/modal-overlay';
import { NoPartyGroupEditComponent } from '@app/src/app/shared/components/no-party-group-edit';
import { SystemAlertSnackBarService } from '@app/src/app/shared/components/system-alert-snackbar';

import { FtmRestrictionsMessage } from './constants';
import { FtmRestrictionsService } from './services/ftm-restrictions.service';

@Component({
  selector: 'mg-ftm-restrictions',
  templateUrl: './ftm-restrictions.component.html',
  styleUrls: ['./ftm-restrictions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FtmRestrictionsComponent implements OnInit {
  // Constants
  public readonly MSG = FtmRestrictionsMessage;
  public readonly NO_PARTY_LIST_TYPE: MembershipListType[] = [MembershipListType.NO_PARTY];
  public readonly NO_PASS_LIST_TYPES: MembershipListType[] = [MembershipListType.FLEX_NO_REGISTRATION];

  public readonly NO_PARTY_FLAG = MembershipListFlags.FLEX_TIME_ENABLED;

  // Observables
  public refreshNPListSubject = new Subject<void>();

  // Component Constructor

  constructor(
    private _ftmRestrictions: FtmRestrictionsService,
    private _modalOverlay: ModalOverlayService,
    private _snackBar: SystemAlertSnackBarService,
  ) {}

  // Lifecycle Hooks
  ngOnInit(): void {
    this._ftmRestrictions.fetchList();
  }

  // Public Methods

  public async openRestrictionsEditModal(item?: MembershipListTableData) {
    const restrictionsEditModal = this._modalOverlay.open(NoPartyGroupEditComponent, {
      disposeOnNavigation: false,
      data: item
        ? {
            isNewList: item.id,
            list: item,
          }
        : undefined,
    });

    const response = await lastValueFrom(restrictionsEditModal.afterClosed);

    if (
      [
        ModalOverlayServiceCloseEventType.CREATE,
        ModalOverlayServiceCloseEventType.SUBMIT,
        ModalOverlayServiceCloseEventType.DELETE,
      ].includes(response.type)
    ) {
      if (response.type === ModalOverlayServiceCloseEventType.CREATE) {
        this._snackBar.success('No party group created');
      } else if (response.type === ModalOverlayServiceCloseEventType.SUBMIT) {
        this._snackBar.success('No party group updated');
      } else if (response.type === ModalOverlayServiceCloseEventType.DELETE) {
        this._snackBar.success('No party group deleted');
      }
      this.refreshNPListSubject.next();
    }
  }
}
